module.exports = __webpack_public_path__ + "static/img/AuditionCourse.66fc513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AuditionCourse.png
// module id = 1XnS
// module chunks = 20